export interface ProfileSectionList {
  title: string;
  data: ProfileSectionItem[];
}

export interface ProfileSectionItem {
  title: string;
}

export const PROFILE = [
  {
    title: 'About app',
    data: [
      {title: 'Privacy policy'},
      {title: 'Terms and Conditions'},
      {title: 'Log out'},
    ],
  },
];
